export default __webpack_public_path__ + "static/media/Farazandishan-logo-1.48c89e9f.png";